module.exports = "https://static.wmbcdn.com/uniweb/images/babf8f9672efa183b4fe97c161671d8d.svg";